import { createSlice } from '@reduxjs/toolkit';

const webAdminList = [
  'tyler.chen@acercsi.com',
  'joe.sc.liu@acercsi.com',
  'esther.huang@acercsi.com',
  'michael.kuo@acercsi.com',
  'lulu.chen@acercsi.com',
  'leena.chang@acercsi.com',
  'mcgill.chen@acercsi.com',
];

// 重新整理時 store 會重建，直接從 localStorage 初始化，避免第一次 render 時
// isAdmin 為 false，導致 ProtectedRoute 把 admin 頁面導回 /HomePage
const initialEmail = localStorage.getItem('user_email') || '';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    email: initialEmail,
    isAdmin: webAdminList.includes(initialEmail),
  },
  reducers: {
    setUser(state, action) {
      const email = action.payload.email;
      state.email = email;
      state.isAdmin = webAdminList.includes(email);
    },
    clearUser(state) {
      state.email = '';
      state.isAdmin = false;
    }
  }
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
